import React, { FC, ReactNode } from "react";
import { useAuthContext } from "../../features/auth/model/useAuthContext";
import Box from "../../shared/ui/display/Box";
import Container from "../../shared/ui/display/Container";
import Navbar from "../../shared/ui/navigation/Navbar";
import useStyles from "./useStyles";
import { FormContextProvider } from "../../shared/ui/contexts/FormContext";

type AuthenticatedLayoutProps = {
  children: ReactNode;
};

const AuthenticatedLayout: FC<AuthenticatedLayoutProps> = ({ children }) => {
  const { layoutRoot, containerRoot } = useStyles();
  const { signOut } = useAuthContext();

  return (
    <Box className={layoutRoot}>
      <Navbar onLogOutClick={signOut} />
      <Container className={containerRoot}>
        <FormContextProvider>{children}</FormContextProvider>
      </Container>
    </Box>
  );
};

export default AuthenticatedLayout;
